/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `created` - created
 * * `uploaded` - uploaded
 * * `processed` - processed
 * * `error` - error
 * * `removed` - removed
 * @export
 */
export const FileStateEnum = {
  CREATED: "created",
  UPLOADED: "uploaded",
  PROCESSED: "processed",
  ERROR: "error",
  REMOVED: "removed",
} as const;
export type FileStateEnum = (typeof FileStateEnum)[keyof typeof FileStateEnum];

export function instanceOfFileStateEnum(value: any): boolean {
  for (const key in FileStateEnum) {
    if (Object.prototype.hasOwnProperty.call(FileStateEnum, key)) {
      if (FileStateEnum[key as keyof typeof FileStateEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FileStateEnumFromJSON(json: any): FileStateEnum {
  return FileStateEnumFromJSONTyped(json, false);
}

export function FileStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileStateEnum {
  return json as FileStateEnum;
}

export function FileStateEnumToJSON(value?: FileStateEnum | null): any {
  return value as any;
}

export function FileStateEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FileStateEnum {
  return value as FileStateEnum;
}
